import { render, staticRenderFns } from "./EditCompetition.vue?vue&type=template&id=393dbf5c&scoped=true"
import script from "./EditCompetition.vue?vue&type=script&lang=js"
export * from "./EditCompetition.vue?vue&type=script&lang=js"
import style0 from "./EditCompetition.vue?vue&type=style&index=0&id=393dbf5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393dbf5c",
  null
  
)

export default component.exports